import React, { useEffect, useMemo, useState } from "react";
import AccountSettingSidebar from "../../../component/common/layout/AccountSettingSidebar";
import LeftSidebarNew from "../../../component/common/layout/LeftSidebarNew";
import SurveyListHeader from "../../../component/common/layout/SurveyListHeader";
import Svg from "../../../component/common/Svg";
import Card from "../../../core/Card";
import style from "../../style.module.css";
import Input from "../../../core/Inputs/DefaultInput";
import UserPermissionsEmpty from "./empty-state/UserPermissions";
import SearchInput from "../../../core/Inputs/SearchInput";
import userIcon from "../../../assets/images/survey-image-4.png";
import { useTranslation } from 'react-i18next';
import DataTable from "react-data-table-component";
import SurveyListSidebar from "../../../component/common/layout/SurveyListSidebar";
import { Link } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import {
  addUser,
  deleteUser,
  editUser,
  getUserList,
} from "../../../store/actions/userActions";
import { apiRequest } from "../../../services/apiService";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { addUserSchema, editUserSchema } from "../../../schema/User";
import NestedMenuToggle from "./NestedMenuToggle";
import {
  timezoneList,
} from "../../../store/actions/locationActions";

const pwdChecks = [
  { key: 'length',  label: 'At least 12 characters', test: (p) => p.length >= 12 },
  { key: 'upper',   label: 'Uppercase letter',        test: (p) => /[A-Z]/.test(p) },
  { key: 'lower',   label: 'Lowercase letter',        test: (p) => /[a-z]/.test(p) },
  { key: 'number',  label: 'Number',                  test: (p) => /[0-9]/.test(p) },
  { key: 'special', label: 'Special character',       test: (p) => /[^A-Za-z0-9]/.test(p) },
];
const getPwdStrength = (p) => {
  const n = pwdChecks.filter(c => c.test(p)).length;
  if (!p) return { level: 0, label: '', color: '' };
  if (n <= 1) return { level: 1, label: 'Weak',   color: '#e53935' };
  if (n <= 3) return { level: n,  label: 'Fair',   color: '#fb8c00' };
  if (n === 4) return { level: 4, label: 'Strong', color: '#43a047' };
  return            { level: 5,  label: 'Strong', color: '#43a047' };
};
const PwdCheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <circle cx="9" cy="9" r="9" fill="#22c55e"/>
    <path d="M5 9l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const PwdCrossIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <circle cx="9" cy="9" r="8.5" fill="#f3f4f6" stroke="#d1d5db"/>
    <path d="M5 9l3 3 5-5" stroke="#d1d5db" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
export default function UserPermissions() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  // const { roleData: roleList } = useSelector((state) => state.roleData);
  const {
    userData: userData,
    isAddingUser,
    isDeleteUser,
  } = useSelector((state) => state.userData);

  useEffect(() => {
    if (!isAddingUser) {
      let addUser = document.getElementById("addUserModal");
      let userModal = window.bootstrap.Modal.getOrCreateInstance(addUser);
      if (userModal && userModal._isShown) {
        userModal.hide();
        getUsers();
      }
    }
    if (isAddingUser) {
      let addUserSuccess = document.getElementById("addUserSuccess");
      let userSuccessModal =
        window.bootstrap.Modal.getOrCreateInstance(addUserSuccess);
      if (userSuccessModal && !userSuccessModal._isShown) {
        userSuccessModal.show();
      }
    }
  }, [isAddingUser]);




  useEffect(() => {
    if (!isDeleteUser) {
      let deleteUser = document.getElementById("deleteModal");
      let deleteUserModal =
        window.bootstrap.Modal.getOrCreateInstance(deleteUser);
      if (deleteUserModal && deleteUserModal._isShown) {
        deleteUserModal.hide();
        getUsers();
      }
    }
  }, [isDeleteUser]);

  const [isEdit, setIsEdit] = useState(false);
  const [editUserData, setEditUserData] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [pwdFocused, setPwdFocused] = useState(false);

  const [deleteUserId, setDeleteUserId] = useState(null);
  const [deactivateUserId, setDeactivateUserId] = useState(null);
  const [serverParams, setServerParams] = useState({
    startingLimit: '',
    resultsPerPage: '',
    search: "",
  });
  const [timeZones, setTimeZones] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([
    { value: "en", label: "English" },
    { value: "pt", label: "Portuguese" },
    { value: 'sq', label: 'Albanian' }
  ]);
  const { countryData, regionData, timeZoneData } = useSelector(
    (state) => state.locationData
  );
  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const getUsers = async () => {
    dispatch(getUserList(serverParams));
  };

  const isUserLocked = (row) => {
    return row.locked_until && new Date(row.locked_until) > new Date();
  };

  const handleUnlockUser = async (userId) => {
    try {
      const { response, error } = await apiRequest({
        method: "POST",
        url: "/users/unlock-user",
        data: { user_id: userId },
        showErrorToast: false,
      });
      if (response?.data?.statusCode === 200) {
        toast.success("User unlocked successfully");
        getUsers();
      } else {
        toast.error(error?.response?.data?.msg || "Failed to unlock user");
      }
    } catch (e) {
      toast.error("Failed to unlock user");
    }
  };

  const handleToggleUserStatus = async (userId, isDeactivated) => {
    try {
      const { response, error } = await apiRequest({
        method: "POST",
        url: "/users/toggle-user-status",
        data: { user_id: userId, activate: isDeactivated ? true : false },
        showErrorToast: false,
      });
      if (response?.data?.statusCode === 200) {
        toast.success(response.data.msg);
        getUsers();
      } else {
        toast.error(error?.response?.data?.msg || "Failed to update user status");
      }
    } catch (e) {
      toast.error("Failed to update user status");
    }
  };

  const getTimezones = async () => {
    dispatch(timezoneList());
  };

  const editDataById = (editData) => {
    setIsEdit(true);
    setEditUserData(editData);

    formik.setFieldValue("name", editData.name);
    formik.setFieldValue("email", editData.email);
    formik.setFieldValue("default_language", editData.default_language);
    formik.setFieldValue("timezone", editData.timezone);
    formik.setFieldValue("password", "********");

    let addUser = document.getElementById("addUserModal");
    let userModal = window.bootstrap.Modal.getOrCreateInstance(addUser);
    if (userModal && !userModal._isShown) {
      userModal.show();
    }
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
      roles: "",
      default_language: "",
      timezone: "",
    },
    validationSchema: !isEdit ? addUserSchema : editUserSchema,
    // onSubmit: (values) => {
    //   console.log("value-----", values);
    //   delete values.roles;
    //   values.roles = [values.roles];
    //   if (isEdit) {
    //     values.user_id = editUserData.id;
    //     delete values.password;
    //     editUserApi(values);
    //   } else {
    //     addUserData(values);
    //     formik.resetForm({
    //       values: {
    //         name: '',
    //         email: '',
    //         password: '',
    //         roles: '',
    //         default_language: '',
    //         timezone: '',
    //       },
    //     });
    //     setIsEdit(false);
    //     setEditUserData(null);
    //   }
    // },
    onSubmit: (values) => {
      // Prepare the payload common for both add and edit
      const payload = {
        name: values.name,
        email: values.email,
        default_language: values.default_language,
        timezone: values.timezone,
        roles: [values.roles],
      };

      if (isEdit) {
        payload.user_id = editUserData.id;
        // Only include the new password if the user changed it
        if (values.password && values.password !== "********") {
          payload.password = values.password;
        }
        editUserApi(payload);
      } else {
        // For add user, password is required.
        payload.password = values.password;
        addUserData(payload);
        formik.resetForm({
          values: {
            name: '',
            email: '',
            password: '',
            roles: '',
            default_language: '',
            timezone: '',
          },
        });
        formik.setFieldValue("default_language", "");
        formik.setFieldValue("timezone", "");
        setIsEdit(false);
        setEditUserData(null);
      }
    },

  });

  const addUserData = async (payload) => {
    dispatch(addUser(payload));

  };
  const editUserApi = async (payload) => {
    dispatch(editUser(payload));

    // if (formik.values.default_language) {
    //   i18n.changeLanguage(formik.values.default_language); // Change language using i18next
    //   localStorage.setItem('i18nextLng', formik.values.default_language); // Save language preference
    //}
  };
  const deleteUserData = async () => {
    let payload = { id: deleteUserId };
    dispatch(deleteUser(payload));
  };
  const columns = [
    {
      name: t('settings.users_and_teams.users.name'),

      cell: (row) => (
        <>
          <div className="d-flex table-profile align-items-center">
            <div className="img-wrapper">
              {/* <img src={userIcon} alt="" /> */}
              <span>{row.name.substring(0, 2).toUpperCase()}</span>
            </div>
            <div className="flex-grow-1 ps-3">
              <h5>{row.name}</h5>
              <p>{row.email}</p>
            </div>
          </div>
        </>
      ),
    },
    {
      name: t('settings.account_settings.default_language'),
      selector: 'default_language', // Key from row data
      cell: (row) => (
        <span>{selectedLanguages.find(lang => lang.value === row.default_language)?.label || row.default_language}</span>
      ),
    },

    {
      name: t('survey.status'),
      selector: 'is_active',
      cell: (row) => {
        if (row.is_deactivated == 1) {
          return <span className="table-status Inactive">Inactive</span>;
        }
        if (isUserLocked(row)) {
          return <span className="table-status Inactive">Locked</span>;
        }
        let statusText = '';
        switch (row.is_active) {
          case 0:
            statusText = 'Invited';
            break;
          case 1:
            statusText = 'Active';
            break;
          default:
            statusText = 'Unknown';
            break;
        }

        return <span className={`table-status ${statusText}`}>{statusText}</span>;
      },
    },


    {
      name: t('settings.account_settings.timezone'),
      selector: 'timezone', // Key from row data
      cell: (row) => (
        <span>{timeZones.find(zone => zone.value === row.timezone)?.label || row.timezone}</span>
      ),
    },
    {
      name: t('settings.users_and_teams.users.action'),

      cell: (row) => (
        <>
          <div className="d-flex action-wrapper">
            {isUserLocked(row) && (
              <a
                href="#"
                className="action-btn"
                title="Unlock user"
                onClick={(e) => {
                  e.preventDefault();
                  handleUnlockUser(row.id);
                }}
              >
                <i className="fa fa-unlock" style={{ color: '#e60000', fontSize: '14px' }}></i>
              </a>
            )}
            {window.modulePermissions.M3.edit == 1 && (
              <a
                href="#"
                className="action-btn"
                onClick={() => {
                  editDataById(row);
                }}
              >
                <Svg name="table-edit" />
              </a>
            )}
            {window.modulePermissions.M3.del == 1 && row.is_deactivated != 1 && (
              <a
                href="#"
                className="action-btn"
                title="Deactivate user"
                data-bs-toggle="modal"
                data-bs-target="#deactivateModal"
                onClick={(e) => {
                  e.preventDefault();
                  setDeactivateUserId(row.id);
                }}
              >
                <Svg name="table-delete" />
              </a>
            )}
            {window.modulePermissions.M3.del == 1 && row.is_deactivated == 1 && (
              <a
                href="#"
                className="action-btn"
                title="Activate user"
                onClick={(e) => {
                  e.preventDefault();
                  handleToggleUserStatus(row.id, true);
                }}
              >
                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="#28a745" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M3.41003 22C3.41003 18.13 7.26003 15 12 15C12.96 15 13.89 15.13 14.76 15.37" stroke="#28a745" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16.5 19.5L18 21L22 17" stroke="#28a745" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            )}
          </div>
        </>
      ),
    },
  ];

  useEffect(() => {
    getUsers();
  }, [serverParams]);


  useEffect(() => {
    let tempTimeZones = [];
    Object.keys(timeZoneData).map((ele) => {
      tempTimeZones.push({
        value: timeZoneData[ele].utc[0],
        label: timeZoneData[ele].text,
      });
      setTimeZones(tempTimeZones);
    });
  }, [timeZoneData]);

  useEffect(() => {
    //  getRegionList();
    getTimezones();
    //getUserDetail();
  }, []);

  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper bg-white">
        <SurveyListHeader />
        <div id="viewport" className="d-flex bg-white">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <AccountSettingSidebar />
            <div className="flex-grow-1 page-content-wrap d-flex flex-column">
              <div className="page-heading d-md-flex align-items-center">
                <div className="flex-grow-1">
                  {/* breadcrumbs here */}
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/admin/settings/profile">{t('settings.title')}</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/admin/settings/user-permissions">{t('settings.users_and_teams.breadcrumb_heading')}</Link>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        <strong>{t('settings.users_and_teams.users.heading')}</strong>
                      </li>
                    </ol>
                  </nav>
                  {/* breadcrumbs ends here */}
                  <div className="d-flex align-items-center">
                    <NestedMenuToggle />
                    <div className="flex-grow-1 ps-3 ps-lg-0">
                      <h1>{t('settings.users_and_teams.users.heading')}</h1>
                      <p className='pt-2 mb-0'>{t('settings.users_and_teams.users.sub_heading')} </p>
                    </div>
                  </div>
                </div>
                {window.modulePermissions.M3.add == 1 && (
                  <div className="button-wrap pt-3 pt-md-0">
                    <button
                      type="button"
                      className="btn btn-primary add-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#addUserModal"
                      srno="1"
                      value="1"
                      onClick={() => {
                        setIsEdit(false);
                        setEditUserData(null);
                        formik.resetForm({
                          values: {
                            name: '',
                            email: '',
                            password: '',
                            roles: '',
                            default_language: '',
                            timezone: '',
                          }
                        });
                      }}
                    >
                      <Svg name="plus" /> {t('settings.users_and_teams.users.create_user.heading')}{" "}
                    </button>
                  </div>
                )}
              </div>
              <div className="role-wrapper flex-grow-1">
                {/* Empty State of User Role */}
                {/* <UserPermissionsEmpty /> */}
                <div className="table-wrapper-view">
                  <div className="search-filter d-md-flex align-items-center">
                    <div className="flex-grow-1 search-filter-padding">
                      <SearchInput
                        className="custom-search-input"
                        type="def"
                        view="outlined"
                        color="primary"
                        placeholder={t('settings.users_and_teams.users.search')}

                        fill={true}
                        onChange={(e) => {
                          setServerParams({
                            ...serverParams,
                            search: e.target.value,
                          });
                        }}
                        onClear={() => {
                          setServerParams({
                            ...serverParams,
                            search: "",
                          });
                        }}
                      />
                    </div>
                    {/* <div className="drop-wrap d-flex align-items-center">
                      <label>Sort By - </label>
                      <div className="dropdown table-dropdown ques-options">
                        <button
                          className="btn dropdown-tgl"
                          type="button"
                          id="languages"
                          data-bs-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Recently added
                        </button>
                        <div
                          className="dropdown-menu"
                          aria-labelledby="languages"
                        >
                          <a className="dropdown-item" href="#">
                            {" "}
                            Value 1{" "}
                          </a>
                          <a className="dropdown-item" href="#">
                            {" "}
                            Value 2{" "}
                          </a>
                          <a className="dropdown-item" href="#">
                            {" "}
                            Value 3{" "}
                          </a>
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div className="table-wrap custom-data-table">
                    {userData.length > 0 && (
                      <DataTable
                        columns={columns}
                        data={userData}
                        //selectableRows
                        // onSelectedRowsChange={handleRowSelected}
                        // clearSelectedRows={toggleCleared}
                        pagination
                      // paginationComponent={(props) => {
                      //   return (
                      //     <Pagination
                      //       currentPage={currentPage}
                      //       totalPage={2}
                      //       gotoPreviousPage={gotoPreviousPage}
                      //       changePage={changePage}
                      //       geToNextPage={geToNextPage}
                      //     />
                      //   );
                      // }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal fade setting-modal"
        id="addUserModal"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer"}>
                <div
                  className={
                    "formvawrapper modal-setting-medium" + " " + style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-4" + " " + style.card}
                  >
                    <div className="modal-heading">
                      <h4>{isEdit ? t('settings.roles.create_role.edit')
                        : t('settings.roles.create_role.add_new')
                      } {t('settings.users_and_teams.users.heading')}
                      </h4>
                    </div>
                    <form onSubmit={formik.handleSubmit} autoComplete="off">
                      <div className="form-wrapper input-margin-zero mt-3">
                        <div className="row">
                          <div className="col-lg-12 ">
                            <div className="form-group mb-3 position-relative">
                              <label>{t('settings.users_and_teams.users.create_user.full_name')}<span className="text-primary">*</span></label>
                              <Input
                                type="text"
                                view="outlined"
                                dense={false}
                                color="default"
                                name="name"
                                label=""
                                placeholder={`${t('settings.users_and_teams.users.create_user.enter')} ${t('settings.users_and_teams.users.create_user.full_name')}`}
                                clearButton={true}
                                success={false}
                                error={false}
                                fill={true}
                                errorHelperText={null}
                                className={"formsinput"}
                                onChange={formik.handleChange}
                                value={formik.values.name}

                              />
                              {/* <p className="help-text">
                              You can add or invite upto 10 people at a time
                            </p> */}
                              {formik.errors.name && formik.touched.name && (
                                <div className="validation-msg">
                                  {formik.errors.name}
                                </div>
                              )}
                            </div>
                          </div>
                          {/* <div className="col-auto">
                          <div className="or-text">Or</div>
                        </div> */}
                          <div className="col-lg">
                            <div className="form-group mb-3 position-relative">
                              <label>{t('settings.users_and_teams.users.create_user.email_address')}<span className="text-primary">*</span></label>
                              <Input
                                type="email"
                                view="outlined"
                                dense={false}
                                color="default"
                                label=""
                                placeholder={`${t('settings.users_and_teams.users.create_user.enter')} ${t('settings.users_and_teams.users.create_user.email_address')}`}
                                clearButton={false}
                                success={false}
                                error={false}
                                fill={true}
                                errorHelperText={null}
                                className={"formsinput"}
                                name="email"
                                autoComplete="new-email"

                                onChange={formik.handleChange}
                                value={formik.values.email}

                              />
                              {formik.errors.email && formik.touched.email && (
                                <div className="validation-msg">
                                  {formik.errors.email}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* <div className="col-lg ">
                            <div className="form-group mb-3 position-relative">
                              <label>{t('settings.users_and_teams.users.create_user.password')}*</label>
                              <Input
                                type="password"
                                view="outlined"
                                dense={false}
                                color="default"
                                label=""
                                placeholder={`${t('settings.users_and_teams.users.create_user.enter')} ${t('settings.users_and_teams.users.create_user.password')}`}
                                clearButton={false}
                                success={false}
                                error={false}
                                fill={true}
                                errorHelperText={null}
                                className={"formsinput"}
                                name="password"
                                autoComplete="new-password"
                                onFocus={(e) => e.target.removeAttribute('readOnly')}

                                onChange={formik.handleChange}
                                onClick={handleTogglePasswordVisibility}
                              />
                              <i
                                className={`${showPassword ? "fa fa-eye-slash" : "fa fa-eye"
                                  }`}
                              ></i>
                              {formik.errors.password &&
                                formik.touched.password && (
                                  <div className="validation-msg">
                                    {formik.errors.password}
                                  </div>
                                )}
                            </div>
                          </div> */}

                          <div className="col-lg">
                            <div className="form-group mb-3 position-relative">
                              <label>{t('settings.users_and_teams.users.create_user.password')}<span className="text-primary">*</span></label>
                              <div
                                className="position-relative"
                                onFocus={() => setPwdFocused(true)}
                                onBlur={(e) => {
                                  if (!e.currentTarget.contains(e.relatedTarget)) {
                                    setPwdFocused(false);
                                  }
                                }}
                              >
                                <Input
                                  type={showPassword ? "text" : "password"}
                                  view="outlined"
                                  dense={false}
                                  color="default"
                                  label=""
                                  placeholder={`${t('settings.users_and_teams.users.create_user.enter')} ${t('settings.users_and_teams.users.create_user.password')}`}
                                  clearButton={false}
                                  success={false}
                                  error={false}
                                  fill={true}
                                  errorHelperText={null}
                                  autoComplete="new-password"
                                  className="formsinput"
                                  name="password"
                                  onChange={formik.handleChange}
                                  value={formik.values.password}
                                />
                                <i
                                  className={`toggle-password-icon fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                                  onClick={handleTogglePasswordVisibility}
                                  style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}
                                  aria-hidden="true"
                                  tabIndex={-1}
                                />

                              {/* Live strength bar + checklist — only when typing a new password */}
                              {pwdFocused && formik.values.password && formik.values.password !== '********' && (() => {
                                const pwd = formik.values.password;
                                const strength = getPwdStrength(pwd);
                                const passed = pwdChecks.map(c => ({ ...c, ok: c.test(pwd) }));
                                return (
                                  <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 999, marginTop: 4, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: '12px 14px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                                      <span style={{ fontSize: 13, color: '#374151', fontWeight: 500 }}>Password strength</span>
                                      <span style={{ fontSize: 13, fontWeight: 600, color: strength.color }}>{strength.label}</span>
                                    </div>
                                    <div style={{ display: 'flex', gap: 3, marginBottom: 10 }}>
                                      {[1,2,3,4,5].map(s => (
                                        <div key={s} style={{ flex: 1, height: 5, borderRadius: 3, backgroundColor: s <= strength.level ? strength.color : '#e5e7eb', transition: 'background-color 0.3s' }} />
                                      ))}
                                    </div>
                                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                      {passed.map(c => (
                                        <li key={c.key} style={{ fontSize: 13, marginBottom: 6, color: c.ok ? '#111827' : '#9ca3af', display: 'flex', alignItems: 'center', gap: 8 }}>
                                          {c.ok ? <PwdCheckIcon /> : <PwdCrossIcon />}
                                          {c.label}
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                );
                              })()}
                              </div>

                              {formik.touched.password && formik.errors.password && (
                                <div className="validation-msg">
                                  {formik.errors.password}
                                </div>
                              )}
                            </div>
                          </div>


                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3 cstom-select position-relative">
                              <label htmlFor="">{t('settings.account_settings.timezone')}<span className="text-primary">*</span></label>
                              <Select
                                // value={
                                //   timeZones.find(option => option.value === formik.values.timezone || null)
                                // }
                                value={
                                  timeZones.find(option => option.value === formik.values.timezone) || null
                                }
                                placeholder={t('settings.account_settings.timezone')}
                                options={timeZones}
                                onChange={(e) => formik.setFieldValue('timezone', e.value)}
                              />
                              {formik.errors.timezone && formik.touched.timezone && (
                                <div className="validation-msg">
                                  {formik.errors.timezone}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 position-relative">
                            <div className="mb-3 cstom-select position-relative">
                              <label htmlFor="">{t('settings.account_settings.default_language')}<span className="text-primary">*</span></label>
                              <Select
                                // value={
                                //   selectedLanguages.find(option => option.value === formik.values.default_language || null)
                                // }
                                value={
                                  selectedLanguages.find(option => option.value === formik.values.default_language) || null
                                }
                                placeholder={t('settings.account_settings.default_language')}
                                options={selectedLanguages}
                                onChange={(e) => formik.setFieldValue('default_language', e.value)}
                              />
                            
                                {formik.errors.default_language && formik.touched.default_language && (
                                <div className="validation-msg">
                                  {formik.errors.default_language}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>


                        {/* <div className="permission-wrapper-outer form-group mb-3 d-none">
                          <label>Permissions</label>
                          <div className="permission-wrapper">
                            {roleList?.map((role, key) => {
                              return (
                                <div className="check-wrap" key={key}>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      name="roles"
                                      type="radio"
                                      id={role?.id}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "roles",
                                          e.target.id
                                        );
                                      }}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={role?.id}
                                    >
                                      {role?.role_name}
                                    </label>
                                  </div>
                                </div>
                              );
                            })} */}
                        {/* <div className="row">

                            <div className="col-lg-3 mb-3">
                              <div className="check-wrap">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="UserPermissionAdmin"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="UserPermissionAdmin"
                                  >
                                    Admin
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-3 mb-3">
                              <div className="check-wrap">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="UserPermissionSurveyAdmin"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="UserPermissionSurveyAdmin"
                                  >
                                    Survey admin
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-3 mb-3">
                              <div className="check-wrap">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="UserPermissionRead"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="UserPermissionRead"
                                  >
                                    Read
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-3 mb-3">
                              <div className="check-wrap">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="UserPermissionWrite"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="UserPermissionWrite"
                                  >
                                    Write
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div> */}
                        {/* </div>
                        </div> */}
                      </div>

                      <div className="button-wrap d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-bordered"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            // Just reset local state / form state
                            formik.resetForm();
                            setIsEdit(false);
                            setEditUserData(null);
                          }}
                        >
                          {t('settings.users_and_teams.users.create_user.cancel')}
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary  ms-3"
                        // data-bs-dismiss="modal"
                        // data-bs-toggle="modal"
                        // data-bs-target="#addUserSuccess"
                        >
                          {/* <Svg name="plus" /> */}
                          {t('settings.users_and_teams.users.create_user.save')}
                          {/* {isEdit ? "Edit" : "Add"} User */}
                        </button>
                      </div>
                    </form>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal fade setting-modal"
        id="addUserSuccess"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div
                  className={
                    "formvawrapper modal-setting-medium" + " " + style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-4" + " " + style.card}
                  >
                    <div className="modal-success">
                      <div className="icon-wrap">
                        <svg
                          width={220}
                          height={220}
                          viewBox="0 0 220 220"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx={110} cy={110} r={110} fill="#16C79A" />
                          <path
                            d="M74 124.573L91.567 142L146 88"
                            stroke="white"
                            strokeWidth={9}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="text-wrap">
                        <h4>User {isEdit ? "updated" : "added"}</h4>
                        <p>
                          {isEdit ? "" : "New"} user has been{" "}
                          {isEdit ? "updated" : "added"} Successfully
                        </p>
                      </div>
                      <div className="button-wrap">
                        <button
                          type="button"
                          className="btn btn-primary "
                          data-bs-dismiss="modal"
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal custom-modal fade deleteModal"
        id="deleteModal"
        tabIndex={-1}
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div
                  className={
                    "formvawrapper delete-modal-wrap modal-setting-medium" +
                    " " +
                    style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-0" + " " + style.card}
                  >
                    <div className="delete-body-wrap delete-language">
                      <div className="heading">
                        <h3>
                          {t('settings.users_and_teams.users.delete_action.heading')}
                        </h3>
                        <p>
                          {t('settings.users_and_teams.users.delete_action.text1')}{" "}
                        </p>
                      </div>
                      <div className="warning-message">
                        <div className="title d-flex align-items-center">
                          <svg
                            width={40}
                            height={42}
                            viewBox="0 0 40 42"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20 2L37.3205 32H2.67949L20 2Z"
                              stroke="#F05454"
                              strokeWidth={3}
                              strokeLinejoin="round"
                            />
                            <path
                              d="M20 13.5385V22"
                              stroke="#F05454"
                              strokeWidth={3}
                            />
                            <circle
                              cx="19.9994"
                              cy="25.8461"
                              r={1}
                              fill="black"
                              stroke="#F05454"
                              strokeWidth="1.07692"
                            />
                          </svg>
                          <h4>{t('settings.users_and_teams.users.delete_action.sub_heading')}
                          </h4>
                        </div>
                        <p>
                          {t('settings.users_and_teams.users.delete_action.text2')}
                        </p>
                      </div>

                      <div className="button-wrap d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-bordered color-delete"
                          data-bs-dismiss="modal"
                        >
                          {t('settings.users_and_teams.users.delete_action.cancel')}

                        </button>
                        <button
                          type="button"
                          className="btn btn-delete ms-3"
                          onClick={() => deleteUserData()}
                        >
                          {t('settings.users_and_teams.users.delete_action.confirm_delete')}

                        </button>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal custom-modal fade deleteModal"
        id="deactivateModal"
        tabIndex={-1}
        aria-labelledby="deactivateModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div
                  className={
                    "formvawrapper delete-modal-wrap modal-setting-medium" +
                    " " +
                    style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-0" + " " + style.card}
                  >
                    <div className="delete-body-wrap delete-language">
                      <div className="heading">
                        <h3>Deactivate User</h3>
                        <p>Are you sure you want to deactivate this user?</p>
                      </div>
                      <div className="warning-message">
                        <div className="title d-flex align-items-center">
                          <svg
                            width={40}
                            height={42}
                            viewBox="0 0 40 42"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20 2L37.3205 32H2.67949L20 2Z"
                              stroke="#F05454"
                              strokeWidth={3}
                              strokeLinejoin="round"
                            />
                            <path
                              d="M20 13.5385V22"
                              stroke="#F05454"
                              strokeWidth={3}
                              strokeLinecap="round"
                            />
                            <circle
                              cx="19.9994"
                              cy="25.8461"
                              r={1}
                              fill="black"
                              stroke="#F05454"
                              strokeWidth="1.07692"
                            />
                          </svg>
                          <h4>Warning</h4>
                        </div>
                        <p>
                          This user will be marked as inactive and will no longer be able to log in.
                        </p>
                      </div>

                      <div className="button-wrap d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-bordered color-delete"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-delete ms-3"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            if (deactivateUserId) {
                              handleToggleUserStatus(deactivateUserId, false);
                            }
                          }}
                        >
                          Deactivate
                        </button>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
